// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__3N6Zs","active":"List_active__FH0Db","removeIcon":"List_removeIcon__3XXf7"};